export default __webpack_public_path__ + "static/media/tekaka.c6e61431.jpg";